export default __webpack_public_path__ + "static/media/Peel_Region.13085ed6.svg";